<template>
  <v-form
    :disabled="disabled"
    :style="cssVars"
    :class="(width || defaultWidth) && 'search-input-container'"
    @submit.prevent="onSearch"
  >
    <v-text-field
      v-debounce:250="(e) => (search = e)"
      :value="search"
      class="search-input rounded-0"
      :placeholder="placeholder"
      :label="label"
      :name="name"
      solo
      dense
      :hide-details="hideDetails"
    >
      <template #append>
        <button v-if="!loading" class="red-button card-shadow" type="submit">
          <v-icon :class="buttonClass" :color="buttonColor">
            mdi-magnify
          </v-icon>
        </button>
        <v-progress-circular
          v-else
          indeterminate
          color="white"
          class="red-button card-shadow"
          size="30"
        />
      </template>
    </v-text-field>
  </v-form>
</template>

<script>
  export default {
    name: 'SearchInput',

    props: {
      value: {
        type: String,
        default: '',
      },

      name: {
        type: String,
        default: 'searchItem',
      },

      placeholder: {
        type: String,
        default: 'Buscar',
      },

      label: {
        type: String,
        default: '',
      },

      buttonClass: {
        type: String,
        default: '',
      },

      buttonColor: {
        type: String,
        default: 'white',
      },

      hideDetails: {
        type: Boolean,
        default: false,
      },

      // This component is used in multiple places.
      // Setting a default value for the 'width' prop could unintentionally affect existing usages.
      // To avoid this, we provide an optional 'defaultWidth' boolean prop.
      // Consumers can either enable 'defaultWidth' or pass a custom 'width' value directly.
      width: {
        type: String,
        default: null,
      },
      defaultWidth: Boolean,

      disabled: Boolean,
      loading: Boolean,
    },

    computed: {
      search: {
        set(newValue) {
          this.$emit('input', newValue);
        },
        get() {
          return this.value;
        },
      },

      cssVars() {
        return {
          '--width': this.defaultWidth ? '300px' : this.width,
        };
      },
    },

    methods: {
      onSearch() {
        this.$emit('onSearch', this.value);
      },
    },
  };
</script>

<style scoped>
  .red-button {
    background-color: rgb(200, 32, 49);
    min-height: 38px;
    min-width: 38px;
    margin-right: -12px;
  }

  .search-input {
    border-radius: 0px;
    padding-right: 0px;
  }

  .search-input-container {
    width: var(--width);
  }
</style>
